import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { getPermissions } from "../../utils/various";

const PrivateRoute = ({ children, onlyAdmin }) => {
    const { sessionData } = useSelector(state => state.session);
    if (onlyAdmin) {
        let permissions = getPermissions(sessionData?.role);
        if (!permissions?.admin) {
            return <Navigate to={'/'} replace={true} />
        }
    }
    if (!sessionData) {
        return <Navigate to={'/login'} replace={true} />
    }
    return children;
}

export default PrivateRoute;